<script>
import { PaymentMethodService } from '@/services'
import { usePaymentMethodMethod } from '@/use/payment'

export default {
  inheritAttrs: false,

  model: {
    event: 'change'
  },

  props: {
    value: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      options: [],
      loading: false
    }
  },

  created() {
    this.remoteMethod()
  },

  methods: {
    async remoteMethod(query) {
      this.loading = true

      try {
        const {
          data: { status, result }
        } = await PaymentMethodService.getAll({ search: query })

        if (status === 'error')
          throw new Error(
            'เกิดข้อผิดพลาดระหว่างการรับข้อมูลรายการช่องทางรับชำระเงิน'
          )

        this.options = result.results.map(item => {
          return usePaymentMethodMethod({
            id: item.id,
            name: item.account_name,
            bank: item.bank ? item.bank.name : null,
            accountId: item.bank_account_id,
            isFeeFree: !item.has_fee
          })
        })

        if (this.value && this.options.every(item => item.id !== this.value.id))
          this.options = [...this.options, this.value]
      } finally {
        this.loading = false
      }
    }
  },

  render() {
    return (
      <el-select
        attrs={this.$attrs}
        filterable
        remote
        remoteMethod={this.remoteMethod}
        value={this.value}
        valueKey="id"
        loading={this.loading}
        onChange={value => {
          this.$emit('change', value)
        }}
        nativeOnTouchend={e => {
          e.target.readOnly = false
        }}
      >
        {this.options.map(option => {
          const bankInfo = `${option.bank || ''}: ${option.accountId || ''}`
            .trim()
            .replace(/^:$/, '')
          const label = `${option.name} ${
            bankInfo ? `(${bankInfo})` : ''
          }`.trim()

          return <el-option key={option.id} label={label} value={option} />
        })}
      </el-select>
    )
  }
}
</script>
